import { Card, makeStyles } from "@material-ui/core";
import { DynamicLinkList_dynamicLinks_edges_node } from "@saleor/banners/types/DynamicLinkList";
import CardTitle from "@saleor/components/CardTitle";
import RadioGroupField from "@saleor/components/RadioGroupField";
import { FormChange } from "@saleor/hooks/useForm";
import { maybe } from "@saleor/misc";
import React from "react";
import { useIntl } from "react-intl";

import { BannerDetailsFormData } from "../BannerDetailsPage";

export interface BannerDynamicLinksVerticalProps {
  submitdata: BannerDetailsFormData;
  disabled?: boolean;
  onChange: FormChange;
  dynamicLinkList: DynamicLinkList_dynamicLinks_edges_node[];
}

const useStyles = makeStyles(
  {
    radiogroup: {
      padding: "25px"
    }
  },
  { name: "BannerDynamicLinksVertical" }
);

const BannerDynamicLinksVertical: React.FC<BannerDynamicLinksVerticalProps> = props => {
  const { dynamicLinkList, onChange, submitdata, disabled } = props;
  const intl = useIntl();
  const classes = useStyles(props);

  const verticalProperCase = (
    vertical: DynamicLinkList_dynamicLinks_edges_node
  ) => {
    switch (vertical.name) {
      case "Cinema":
        return "Cinema";
      case "Discounts":
        return "Discounts";
      case "Food":
        return "Food";
      case "Grocery":
        return "Grocery";
      case "Shops":
        return "Shops";
      case "SM Fulfilled":
        return "ShopSM";
      default:
        return " ";
    }
  };

  const dynamicLinkChoices = maybe(
    () =>
      dynamicLinkList.map(data => ({
        label: verticalProperCase(data),
        value: data.id
      })),
    []
  );
  dynamicLinkChoices.push({
    label: "None",
    value: ""
  });

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Featured Verticals",
          description: "header"
        })}
      />
      <RadioGroupField
        disabled={disabled}
        className={classes.radiogroup}
        choices={dynamicLinkChoices}
        onChange={onChange}
        value={submitdata?.dynamicLinkId}
        name={"dynamicLinkId" as keyof BannerDetailsFormData}
      />
    </Card>
  );
};
BannerDynamicLinksVertical.displayName = "BannerDynamicLinksVertical";
export default BannerDynamicLinksVertical;
